module.exports = __webpack_public_path__ + "e25843bc649cfeec099a237f0e13be78.svg";